import { Organization, Profile } from "chq";

const checkCrossTenant = (
  resourceOrganization: Organization,
  profile: Profile
) => !!profile?.organization?.id && !!resourceOrganization?.id
&& profile.organization.id !== resourceOrganization.id;

export default checkCrossTenant;
